import { useNavigate } from "react-router";
import BaseComponent from "../../../shared/baseComponent/BaseComponent";
import { useApiClient } from "../../../shared/customHooks";
import { kindergartenScreeningQuestionsForm } from "../../../shared/formObjects/application/kindergartenScreeningQuestionsForm";
import { useApplicationContext } from "../context/applicationContext";
import { useGlobalContext } from "../../../shared/GlobalContext";

function KindergartenScreeningComponent({ disabled, data }: any) {
  const api = useApiClient("KindergartenInitialApplication");
  const { id } = useApplicationContext();
  const navigate = useNavigate();
  const { addLoadingUrl, removeLoadedUrl, accountInfo } = useGlobalContext();

  const AddUserLinkToToken = async (res: any) => {
    addLoadingUrl("UserLinkLogic");
    await api.forceRefreshToken().then(() => {
      if (accountInfo.isKindergarten) {
        navigate("/kindergarten/pendingApplications/" + res.record.id, { relative: "path" });
      } else if (accountInfo.isAssessorOrManager || accountInfo.isRoot) {
        navigate("/presubmission/" + res.record.id, { relative: "path" });
      }
    });
    removeLoadedUrl("UserLinkLogic");
  };

  return (
    <BaseComponent
      formBody={kindergartenScreeningQuestionsForm(navigate)}
      headerLabel="Screening questions"
      editPath="screeningQuestions"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
      showInternalNotes={false}
      hideCancelButton={true}
      hideSubmitButton={true}
      saveSuccessCB={(res) => {
        AddUserLinkToToken(res);
      }}
      submitPath={null}
    />
  );
}

export default KindergartenScreeningComponent;
